/* Ordinary collection cards: pair the linked size's current and original prices.
 * No collection membership, visibility, filter, link or sort changes. */
(() => {
  const cache = new Map(), done = new WeakMap(), pending = new WeakSet(), queue = [];
  const root = window.Shopify?.routes?.root || '/';
  const format = new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  });
  const money = cents => format.format(cents / 100);
  let running = 0, timer;
  function paint(card, product) {
    const price = card.querySelector('.grid-product__price');
    const link = card.querySelector('a.grid-product__link');
    if (!price || !link) return;
    const id = new URL(link.href).searchParams.get('variant');
    const variant = product.variants.find(v => String(v.id) === id)
      || product.variants.find(v => v.available) || product.variants[0];
    if (!variant || !Number.isFinite(variant.price)) return;
    // Leave regular-price cards and their existing formatting alone.
    if (variant.compare_at_price > variant.price && variant.price > 0) {
      const original = document.createElement('s');
      original.className = 'grid-product__price--original';
      original.textContent = money(variant.compare_at_price);
      const current = document.createElement('strong');
      current.style.color = '#a2476e'; current.textContent = money(variant.price);
      price.replaceChildren(original, document.createTextNode(' '), current);
    }
    done.set(card, {price, text: price.textContent, href: link.href});
  }
  function drain() {
    while (running < 4 && queue.length) {
      const card = queue.shift(), handle = card.dataset.productHandle;
      running++;
      if (!cache.has(handle)) cache.set(handle, fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
        .then(r => { if (!r.ok) throw new Error('Product unavailable'); return r.json(); }));
      cache.get(handle).then(p => { if (card.isConnected) paint(card, p); })
        .catch(() => done.set(card, {failed: true}))
        .finally(() => { running--; pending.delete(card); drain(); });
    }
  }
  function scan() {
    document.querySelectorAll('#gf-products [data-product-handle]').forEach(card => {
      const price = card.querySelector('.grid-product__price');
      const link = card.querySelector('a.grid-product__link');
      const previous = done.get(card);
      if (!price || !link || pending.has(card) || previous?.failed) return;
      if (previous?.price === price && previous.text === price.textContent && previous.href === link.href) return;
      // Only markdown cards need repair; ordinary products incur no extra requests.
      if (!card.querySelector('.grid-product__tag--sale, .grid-product__price--original')) return;
      pending.add(card); queue.push(card);
    });
    drain();
  }
  function start() {
    const target = document.getElementById('CollectionAjaxContent');
    if (!target) return;
    new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(scan, 80); })
      .observe(target, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['href']});
    scan();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
